import { render, staticRenderFns } from "./SchemaEditModal.vue?vue&type=template&id=f92901ce&"
import script from "./SchemaEditModal.vue?vue&type=script&lang=js&"
export * from "./SchemaEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports